import { Action } from '@ngrx/store';
import { LocationModel } from 'src/app/core/_models/location.model';

export enum LayoutActionTypes {
  SplashScreenLoading = '[SplashScreen Loading] Action',
  BreadcrumbsSetSetting = '[Breadcrumbs Set Setting] Action',
  BackgroundWhiteActive = '[Background White Active] Action',
  MenuFooterSetShow = '[Menu Footer Set Show] Action',
  SiderbarSetShow = '[SiderbarSetShow Set Show] Action',
  SetUrlBack = '[Url back set] Action',
  SetUrlNext = '[Url next set] Action',
  SetNavigation = '[Navigation set] Action',
  SetLocation = '[Location set] Action'
}

export class SplashScreenLoading implements Action {
  readonly type = LayoutActionTypes.SplashScreenLoading;
  constructor(public payload: { isLoading: boolean, text?: string }) { }
}

export class BreadcrumbsSetSetting implements Action {
  readonly type = LayoutActionTypes.BreadcrumbsSetSetting;
  constructor(public payload: { title: string | null, btnText: string | null, btnAction: (() => void) | null }) { }
}

export class BackgroundWhiteActive implements Action {
  readonly type = LayoutActionTypes.BackgroundWhiteActive;
  constructor(public payload: { active: boolean }) { }
}

export class MenuFooterSetShow implements Action {
  readonly type = LayoutActionTypes.MenuFooterSetShow;
  constructor(public payload: { show: boolean }) { }
}

export class SiderbarSetShow implements Action {
  readonly type = LayoutActionTypes.SiderbarSetShow;
  constructor(public payload: { show: boolean }) { }
}

export class SetUrlBack implements Action {
  readonly type = LayoutActionTypes.SetUrlBack;
  constructor(public payload: { url: string | null }) { }
}

export class SetUrlNext implements Action {
  readonly type = LayoutActionTypes.SetUrlNext;
  constructor(public payload: { url: string | null }) { }
}

export class SetNavigation implements Action {
  readonly type = LayoutActionTypes.SetNavigation;
  constructor(public payload: { current: string | null, previous: string | null }) { }
}

export class SetLocation implements Action {
  readonly type = LayoutActionTypes.SetLocation;
  constructor(public payload: { location: LocationModel }) { }
}

export type LayoutActions = SplashScreenLoading |
  BreadcrumbsSetSetting |
  BackgroundWhiteActive |
  MenuFooterSetShow |
  SiderbarSetShow |
  SetUrlBack |
  SetUrlNext |
  SetNavigation |
  SetLocation;
